import { memo, useState } from 'react';
import { Container } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useInterval } from '@client/hooks/utils.hooks';
import LoadingAnimation from './V3-animation.gif';

const useStyles = makeStyles({ name: 'LoadingMessage' })((theme) => ({
  root: {
    [theme.breakpoints.down('sm')]: {
      position: 'fixed',
      top: 0,
      left: 0,
      height: '100vh',
      width: '100vw',
      backgroundColor: theme.palette.background.paper,
      padding: 0,
      marginTop: 0,
    },

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    justifySelf: 'center',
    flex: '1 1 auto',
  },
  loading: {
    width: 100,
  },
}));

export const LoadingMessage = memo(() => {
  const { classes } = useStyles();
  const [isDisplayed, setIsDisplayed] = useState(false);

  useInterval(() => {
    setIsDisplayed(true);
  }, 500);

  if (!isDisplayed) {
    return null;
  }

  return (
    <Container
      maxWidth="xs"
      className={classes.root}
    >
      <img
        src={LoadingAnimation}
        alt="Loading"
        className={classes.loading}
      />
    </Container>
  );
});
